import React, { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";

import MenuLinks from "./MenuLinks";

const Menu = ({
  isMobile,
  menuColor,
  isTransparent,
  handleLinkClick,
  headerColor,
  isHomePage,
}) => {
  const [isClosed, setCloseState] = useState(true);
  const [boxShadowClass, setShadowClass] = useState("");
  const containerRef = useRef(null);

  const menuIconStyles = {
    width: isMobile ? 20 : 25,
    height: 1.5,
    backgroundColor: headerColor,
    margin: isMobile ? "5px 0px" : "7px 0px",
    opacity: isClosed ? 1 : 0,
  };

  const menuStatus = isClosed ? "isClosed" : "";

  const menuToggle = useCallback(
    (e) => {
      e.stopPropagation();

      const navLinks = document.getElementsByClassName("navbar-text");
      const companyName = document.getElementsByClassName("site-link");

      for (let i = 0; i < navLinks.length; i++) {
        navLinks[i].style.opacity = isClosed ? 0 : 1;
      }
      for (let i = 0; i < companyName.length; i++) {
        companyName[i].style.opacity = 1;
      }

      setShadowClass(isClosed ? "menu-box-shadow" : "");
      setCloseState(!isClosed);
    },
    [isClosed],
  );

  return (
    <div className='menu-icon-container'>
      {isHomePage && !isMobile && (
        <div className='navbar-links'>
          <Link
            to='/profile'
            className='navbar-text'
            style={{ color: headerColor }}
          >
            PROFILE
          </Link>
          <Link
            className='navbar-text'
            to='/projects'
            style={{ color: headerColor }}
          >
            PROJECTS
          </Link>
          <Link
            className='navbar-text'
            to='/press'
            style={{ color: headerColor }}
          >
            PRESS
          </Link>
        </div>
      )}

      <div
        id='menuButton'
        ref={containerRef}
        className={menuStatus}
        onClick={menuToggle}
      >
        <div className='menuIcon' style={menuIconStyles}></div>
        <div className='menuIcon' style={menuIconStyles}></div>
        <div className='menuIcon' style={menuIconStyles}></div>
      </div>

      <MenuLinks
        menuStatus={menuStatus}
        menuColor={menuColor}
        isTransparent={isTransparent}
        handleLinkClick={handleLinkClick}
        boxShadowClass={boxShadowClass}
        setShadowClass={setShadowClass}
        setCloseState={setCloseState}
        isClosed={isClosed}
        menuToggle={menuToggle}
      />
    </div>
  );
};

export default Menu;
